import moment from 'moment';

export const mapPostForView = (post) => {
  const publishedAt = moment(post.publishedAt);

  return {
    ...post,
    formattedPublishedAt: publishedAt.format('MMMM DD, YYYY'),
  };
};
